export const partition = ['不创建分区', '按日创建分区', '按月创建分区', '按年创建分区'];

export const fieldType = ['浮点型数值型', '整数型数值型', '高精度数值型', '百分比数值型', '字符串', '日期型', '布尔型'];

export const fieldClassify = ['数据期', '维度值', '度量值', '属性值'];

export const dateType = ['日期', '月份', '季度', '年份'];
